/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "customer-users",
	props:{
		companyId: {
			default: null
		}
	},
	data() {
		return {
			customerUsers: [],
			customerUsersHeadings: [
				{
					text: "First Name",
					field: "firstName"
				},
				{
					text: "Last Name",
					field: "lastName"
				},
				{
					text: "Email Address",
					field: "email"
				},
				// {
				// 	text: "Phone Number",
				// 	field: "phoneNumber"
				// },
				{
					text: "Role",
					field: "role"
				},
				{
					text: "Is Active",
					field: "isActive"
				},
				{
					text: "Date Created",
					field: "insertedOn"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			customerUserRoles: [],
			customer: {},
			actions: [],
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				assignVehicles: "assignVehicles",
				resetPassword: "resetPassword"
			},
			customerUserMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveCustomerUserModal",
				heading: "Mark Customer User As Active/Inactive",
				isActive: null,
				userId: null
			},
			assignVehicleToCustomerUserModal:{
				showModal: false,
				isSaving: false,
				modalId: "assignVehicleToCustomerUserModal",
				heading: "Assign Vehicle To Customer User",
				userId: null
			},
			userPasswordResetModal:{
				showModal: false,
				modalId: "userPasswordResetModal",
				header: "Reset User Password",
				userId: null,
				username: null
			},
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				selectedCustomerUserRoleId: 0
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getCustomer(){
			let request = {
				companyId: this.companyId
			};
			customerService.getCompany(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.customer = successResponse.data.result;
						this.setBreadcrumbs();
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerUsers(){
			this.loading = true;
			let request = {
				customerId: this.companyId,
				searchText: this.filter.customerSearchQuery,
				roleId: this.filter.selectedCustomerUserRoleId <= 0 ? null : this.filter.selectedCustomerUserRoleId,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
			};
			securityService.getAllCustomerUsers(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.customerUsers = successResponse.data.result;
						for(let i = 0; i < this.customerUsers.length; i++){
							this.customerUsers[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit,
									elementId: "btnEditCustomerUser"
								},
								{
									name: this.customerUsers[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive,
									elementId: "btnMarkAsActiveInactive"
								},
								{
									name: "Assign Vehicles",
									key: this.actionKeys.assignVehicles,
									elementId: "btnAssignVehicles"
								},
								{
									name: "Reset Password",
									key: this.actionKeys.resetPassword,
									elementId: "btnResetPassword"
								}
							];
							if(roleHelper.role.customerBuyer === this.customerUsers[i].roleId){
								this.customerUsers[i].role = "Buyer";
							}
							else if(roleHelper.role.customerDriver === this.customerUsers[i].roleId){
								this.customerUsers[i].role = "Driver";
							}
							else if(roleHelper.role.customerAdminUser === this.customerUsers[i].roleId){
								this.customerUsers[i].role = "Customer Admin";
							}
							else if(roleHelper.role.customerShiftSupervisor === this.customerUsers[i].roleId){
								this.customerUsers[i].role = "Shift Supervisor";
							}
						}
						this.customerUsers = dataTableHelper.castFieldValues(this.customerUsers);
						this.filterStateChanged = false;
					}
					permissionsHelper.setControlsBasedOnPermissions();
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerUserRoles(){
			// TODO: get from api
			this.customerUserRoles = [
				{
					roleId: roleHelper.role.customerAdminUser,
					role: "Customer User Admin"
				},
				{
					roleId: roleHelper.role.customerBuyer,
					role: "Buyer"
				},
				{
					roleId: roleHelper.role.customerDriver,
					role: "Driver"
				},
				{
					roleId: roleHelper.role.customerShiftSupervisor,
					role: "Shift Supervisor"
				}
			];
			this.customerUserRoles.unshift(
				{
					roleId: 0,
					role: "All"
				});
			console.log("customerUserRoles", this.customerUserRoles);
			this.customerUserRoles = $.map(this.customerUserRoles,
				function (obj) {
					obj.id = obj.id || obj.roleId;
					obj.text = obj.text || obj.role;
					return obj;
				});
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.getCustomerUsers();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onRoleFilterSelect(role){
			if(this.filter.selectedCustomerUserRoleId !== role.id) {
				this.filterStateChanged = true;
			}
			this.filter.selectedCustomerUserRoleId = role.id;
		},
		onAddCustomerUserClick(){
			this.$router.push("/customers/customerUsers/addCustomerUser/" + this.companyId);
		},
		onCustomerUserActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.$router.push("/customers/customerUsers/editCustomerUser/" + actionAndData.data.userId + "/" + this.companyId);
					break;
				case this.actionKeys.markAsActiveInactive:
					this.customerUserMarkAsActiveInactiveModal.showModal = true;
					this.customerUserMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.customerUserMarkAsActiveInactiveModal.userId = actionAndData.data.userId;
					this.customerUserMarkAsActiveInactiveModal.heading = "Mark Customer User As " + (this.customerUserMarkAsActiveInactiveModal.isActive ? "Inactive - " : "Active - ") + actionAndData.data.firstName + " " + actionAndData.data.lastName;
					break;
				case this.actionKeys.assignVehicles:
					this.assignVehicleToCustomerUserModal.showModal = true;
					this.assignVehicleToCustomerUserModal.heading = "Assign Vehicle To Customer User - " + actionAndData.data.firstName + " " + actionAndData.data.lastName;
					this.assignVehicleToCustomerUserModal.userId = actionAndData.data.userId;
					break;
				case this.actionKeys.resetPassword:
					this.userPasswordResetModal.showModal = true;
					this.userPasswordResetModal.userId = actionAndData.data.userId;
					this.userPasswordResetModal.username = actionAndData.data.firstName + " " + actionAndData.data.lastName;
					break;
			}
		},
		onMarkCustomerUserActiveInactiveSelected(isActive){
			this.customerUserMarkAsActiveInactiveModal.isActive = isActive;
			console.log("customerMarkAsActiveInactiveModal.isActive", this.customerUserMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.customerUserMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				userId: this.customerUserMarkAsActiveInactiveModal.userId,
				isActive: markAsActive
			};
			securityService.markUserAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						this.getCustomerUsers();
						this.customerUserMarkAsActiveInactiveModal.showModal = false;
						this.customerUserMarkAsActiveInactiveModal.isActive = true;
						this.customerUserMarkAsActiveInactiveModal.userId = null;
					}
					this.customerUserMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					this.customerUserMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
			var self = this;
			setTimeout(function(){
				self.customerUserMarkAsActiveInactiveModal.isSaving = false;
				self.customerUserMarkAsActiveInactiveModal.showModal = false;
			}, 2000);
		},
		onAssignVehicleToCustomerUserModalOkClicked(){
			this.assignVehicleToCustomerUserModal.showModal = false;
		},
		onPasswordGeneratorOkClicked(){
			this.userPasswordResetModal.showModal = false;
		},
		setBreadcrumbs() {
			var pageTitle = "Customer Users - " + this.customer.registeredCompanyName;
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		//this.setBreadcrumbs();
		this.getCustomerUserRoles();
	},
	watch: {
		companyId: {
			handler: function () {
				if (this.companyId !== null && this.companyId > 0) {
					this.getCustomerUsers();
					this.getCustomer();
				}
			},
			immediate: true,
			deep: true
		}
	}
};